import React, { useState, useEffect } from 'react';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Avatar, Box, Button, Card, CardContent, CardActions, CardHeader, Checkbox, Chip, Divider, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormLabel, FormGroup, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Menu, MenuItem, Radio, RadioGroup, FormControlLabel, Input, InputLabel, Paper, Select, Slide, Stack, TextField, Typography } from '@mui/material/';
import { deepOrange, green, pink, blue, red } from '@mui/material/colors';
import { Close } from '@mui/icons-material/';

//components import
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import AlertInfo from '../../../dataObjects/AlertInfo';

interface Props {
    isNewIssueDialogOpen: boolean,
    letterId: number;
    closeNewIssueDialog: (isNewIssueAdded: boolean) => void
}

interface IssueType {
    issueTypeCode: number;
    description: string;
    display: string;
}

const NewArcherIssueDialog = (props: Props) => {

    // initial state
    const [archerIssueList, setArcherIssueList] = useState<IssueType[]>();

    const [selectedIssueCode, setIssueCode] = useState(999);
    const [specialHeader, setSpecialHeader] = useState("");

    useEffect(() => {
        getArcherIssueList();
    }, []);

    const getArcherIssueList = async () => {
        let url = `/Archer3/GetIssueTypeListings`;
        await fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetIssueTypeListings',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let data = result.result;
                    setArcherIssueList(data);
                }
            })
    }

    const handleClose = () => {
        props.closeNewIssueDialog(false);
    };

    const updateIssueCode = (event: any) => {
        setIssueCode(event.target.value);
    };

    const addNewIssue = (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries((formData as any).entries());
        const issueCode = formJson.issueCode;
        let specialHeader = formJson.specialHeader? formJson.specialHeader: '';
        
        var params = [
            `letterId=${props.letterId}`,
            `issueTypeCode=${issueCode}`,
            `specialHeader=${specialHeader}`
        ].join('&');

        let url = `/Archer3/AddIssue?${params}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: AddIssue',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    //new issue added
                    props.closeNewIssueDialog(true);
                }
            })
    }


    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <div>
            <Dialog
                open={props.isNewIssueDialogOpen}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => addNewIssue(event)
                }}
                fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitle>Add a New Archer Issue...</DialogTitle>
                <DialogContent>
                    <Stack direction="column" spacing={2} sx={{marginTop:2}}>
                        <FormControl fullWidth>
                            <InputLabel>Issue Type</InputLabel>
                            <Select
                                defaultValue={999}
                                name='issueCode'
                                label="Issue Type"
                                onChange={(event) => { updateIssueCode(event)}}
                            >{
                                    archerIssueList && archerIssueList.length>0
                                    && archerIssueList.map((issue: IssueType) =>
                                        <MenuItem key={issue.issueTypeCode} value={issue.issueTypeCode}>{issue.display}</MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                        {
                            selectedIssueCode === 999 &&
                            <TextField
                                margin="dense"
                                name="specialHeader"
                                label="Please provide a header for this special issue"
                                fullWidth
                                variant="standard"
                            />
                        }
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained" color="warning" size="small">Cancel</Button>
                    <Button type="submit" variant="contained" color="success" size="small">Add</Button>
                </DialogActions>
            </Dialog>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
    )
}

export default NewArcherIssueDialog;